import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class StockInoutService {
  private apiUrl = '/stockinouts';
  private apiSpringUrl = '/spring/stockinouts';

  constructor(private http: HttpService) {}

  post(jsonData: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}`;
    return this.http.post(url, jsonData);
  }

  put(jsonData: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl;
    return this.http.put(url, jsonData);
  }

  downloadCsv(jsonData: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}/download/csv`;
    return this.http.post(url, jsonData);
  }  
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/stock-inout/stock-inout.service.ts